/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrentObservationStatusModel } from '../../models/current-observation-status-model';

export interface ConsumerObservationGet$Params {
}

export function consumerObservationGet(http: HttpClient, rootUrl: string, params?: ConsumerObservationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentObservationStatusModel>> {
  const rb = new RequestBuilder(rootUrl, consumerObservationGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CurrentObservationStatusModel>;
    })
  );
}

consumerObservationGet.PATH = '/Consumer/Observation';
